import { Component } from "react";

class EditSchemeInfo extends Component{
    constructor(props){
        super(props);
        this.state={
            code:this.props.selectedScheme ? this.props.selectedScheme.code : "" ,
            name:this.props.selectedScheme ? this.props.selectedScheme.name : "" ,
            id: this.props.selectedScheme ? this.props.selectedScheme.id : "",
            activities: this.props.selectedScheme ? this.props.selectedScheme.activities : []
            }
    }

    handleCodeChange = (event) =>{
        this.setState({code:event.target.value})//setState need an object
    }

    handleNameChange = (event) =>{
        this.setState({name: event.target.value});
        // console.log(event)
    }

    handleActivityChange = (index, event) => {
        const newActivities = [...this.state.activities];
        newActivities[index] = event.target.value;
        this.setState({ activities: newActivities });
    }

    handleActivityDelete = (index) =>{
        const filteredActivities = this.state.activities.filter((activity,i)=> i !== index);//return a new array that filter current object via index
        this.setState({activities:filteredActivities});
    }

    handleAddActivity = () =>{
        this.setState({activities:[...this.state.activities, '']});
    }

    handleSave = () =>{
        const updatedScheme = {
            code: this.state.code,
            name: this.state.name,
            activities: this.state.activities,
            id: this.state.id
        }

        this.props.onUpdateScheme(updatedScheme);//send updated scheme data back to parents
    }

    render(){
        const {selectedScheme} = this.props;

        if(!selectedScheme){
            return <div>No Selected Scheme</div>
        }
        return(
            <div>
                <b>Scheme Name :</b><br />
                <input type="text" className="form-control" placeholder="Scheme name" value={this.state.name} onChange={event => this.handleNameChange(event)}/><br />
                <b>Scheme Code :</b><br />
                <input type="text" className="form-control" placeholder="Scheme code" value={this.state.code} onChange={event => this.handleCodeChange(event)}/><br />
                <b>Scheme Activities :</b><br />
                {this.state.activities.map((activity,index) =>(
                    <div key={index} className="d-flex">
                        <input type="textarea" className="form-control" placeholder="Scheme code" value={activity} onChange={(event) => this.handleActivityChange(index, event)} />
                        <button className=" m-1 btn btn-outline-red" onClick={()=>this.handleActivityDelete(index)}><i className="fas fa-trash"></i></button>
                    </div>)
                )}
                <button className="btn m-2 btn-outline-black" onClick={()=> this.handleAddActivity()}><i className="fas fa-plus"/>{' '}Add Scheme Activities</button>
                <br />
                <div className="mt-5 row justify-content-end">
                    <button type="button" className="btn m-2 btn-outline-black" onClick={this.handleSave}>
                        <i className="fas fa-plus-circle"/>{' '} Save Scheme
                    </button>
                </div>
            </div>
        )
    }
    
}
export default EditSchemeInfo;